import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-404280ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.$t("thankpage.thank")) + " ", 1),
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("thankpage.end")), 1)
        ])
      ])
    ])
  ]))
}